import React, { useEffect, useState, memo } from 'react';
import { useSelector } from 'react-redux';
import { Col } from 'react-bootstrap';
import HTMLReactParser from 'html-react-parser';
import {
  getNavbarHeight,
  isMobileMatchMedia
} from '../../../Core/Hooks/HooksGenerals/UseMediaQuery';
import { useProgressiveImage } from '../../../Core/Hooks/HooksUseImage/UserImage';
import { InterestBrochureForm } from '../InterestBrochureForm/InterestBrochureForm';
import {
  BannerTest,
  bg_default,
  IconoExperiencial,
  LanguageIcon,
  MeetIcon,
  TrainingSectionBg
} from '../../../Resources/Images/ImagesLogo';
import { getScreenImage } from '../../../Domain/Utils/ScreenUtilies/ScreenUtilies';
import '../../../Generals/Styles/Banners.css';
import BtnStudyPlan from '../../Atoms/BtnStudyPlan/BtnStudyPlan';
import BarModality from '../../Atoms/BarModality/BarModality';
import { COURSE_MODE, ID_MULTILANGUGAE } from '../../../Domain/Settings/Constants/Constants';
import TagsInfo from '../TagsInfo/TagsInfo';
// import '../../styles/components/PopUp.css';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import {
  useGetComponentParameters
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';

const BrochureBanner = ({
  strategicLine = {},
  setLoader = () => { },
  parameters,
  scrollToCourseMembership = () => { },
  courseItem,
  parametersBrochure
}) => {
  const [isMobileView, setIsMobileView] = useState(false);
  const [windowInner, setWindowInner] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const imageLoaded = useProgressiveImage(getScreenImage(strategicLine));

  const parametersMlt = useGetComponentParameters(COMPONENTS.COURSE_INFO_SCREEN);

  useEffect(() => {
    const mobileMatchMedia = isMobileMatchMedia();
    const firedMatchMedia = (e) => setIsMobileView(mobileMatchMedia.matches);
    const windowResizeListener = () => {
      setWindowInner({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    firedMatchMedia();
    mobileMatchMedia.addListener(firedMatchMedia); // @see https://github.com/mdn/sprints/issues/858#issuecomment-515238645
    window.addEventListener('resize', windowResizeListener);
    return () => {
      mobileMatchMedia.removeListener(firedMatchMedia);
      window.removeEventListener('resize', windowResizeListener);
    };
  }, []);

  const bannerPrincipalHeiht = windowInner.height - getNavbarHeight();
  const bgImage = imageLoaded || bg_default;
  const backgroundStyle = isMobileView
    ? {
      backgroundImage: `linear-gradient(to bottom, rgba(0,0,0, 0.7) 0%, rgba(0,0,0, 0.2) 60%), url(${bgImage})`
    }
    : {
      backgroundImage: `url(${bgImage})`
    };

  return (
    <div
      className="banner-principal flex-column flex-lg-row justify-content-center align-items-center py-5 px-lg-0"
      style={{
        ...backgroundStyle
      }}>
      <div className="container d-flex flex-column flex-lg-row justify-content-between align-items-center p-0 mb-5 mb-lg-0">
        <Col
          lg={7}
          md={12}
          className="col-12 col-lg-7 justify-content-center justify-content-lg-start align-items-end align-items-lg-center py-5 py-lg-0 p-0">
          <div className="section-info">
            <h3 className="info-title text-center text-lg-start px-3 px-lg-0">
              {strategicLine?.name}
            </h3>
            <p className="info-description text-center text-lg-start px-3 px-lg-0">
              {HTMLReactParser(strategicLine?.description || '', { trim: true })}
            </p>
            <BtnStudyPlan
              title={parametersMlt?.BTN_PROGRAMS}
              scrollToCourseCard={scrollToCourseMembership}
            />
            <TagsInfo
              title={parameters?.MODALITY_LABEL?.value}
              descriptionTitle={courseItem?.mode?.[0]?.multilanguague?.value}
              subtitle={parameters?.LANGUAGE?.value}
              descriptionSub={
                parseInt(courseItem?.multilanguage_id) === ID_MULTILANGUGAE.ESP
                  ? parameters?.ES?.value
                  : parameters?.EN?.value ?? 'Experencial'
              }
              iconTitle={MeetIcon}
              iconSub={IconoExperiencial}
            />
          </div>
        </Col>
        <Col
          lg={5}
          md={12}
          className="section-form-register-container justify-content-center justify-content-lg-end align-items-center px-0 py-4">
          <div className="section-form-register mx-4 mx-lg-0">
            <InterestBrochureForm
              interestData={strategicLine}
              setLoader={setLoader}
              parameters={parametersBrochure}
            />
          </div>
        </Col>
      </div>
    </div>
  );
};

export default memo(BrochureBanner);
